import { NgModule } from '@angular/core';
import { RecaptchaComponent } from './recaptcha.component';
import { RecaptchaAdapters } from './connector/recaptcha-adapters';
import { OccRecaptchaAdapter } from './occ-recaptcha-adapter/recaptcha.adapter';


@NgModule({
  declarations: [RecaptchaComponent],
  exports: [RecaptchaComponent],
  providers: [
    {
      provide: RecaptchaAdapters,
      useClass: OccRecaptchaAdapter,
    },
  ],
})
export class RecaptchaModule {}
